import * as PIXI from "pixi.js";
import { GameAssets } from "src/shared/util/GameAssets";
import { GlobalState } from "src/shared/util/GlobalState";

// Define an enum for the states
export enum FastButtonState {
    ACTIVE = "ACTIVE",
    PASSIVE = "PASSIVE",
}

export class FastButton extends PIXI.Container {
    private sprite: PIXI.Sprite;
    public get Sprite() {
        return this.sprite;
    }
    private currentState: FastButtonState = FastButtonState.PASSIVE;

    constructor() {
        super();

        this.sprite = new PIXI.Sprite(GameAssets.textures.uiAtlas.textures["fastOff.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.sprite.interactive = true;
        this.sprite.on("click", this._handleClick, this);
        this.sprite.on("touchend", this._handleClick, this);

        this.addChild(this.sprite);
    }

    private _handleClick() {
        switch (this.currentState) {
            case FastButtonState.ACTIVE:
                this._changeState(FastButtonState.PASSIVE);
                break;
            case FastButtonState.PASSIVE:
                this._changeState(FastButtonState.ACTIVE);
                break;
        }
    }

    private _onPassive() {
        this.sprite.texture = GameAssets.textures.uiAtlas.textures["fastOff.webp"];
        GlobalState.getInstance().updateState({ fastOn: false });
    }

    private _onActive() {
        this.sprite.texture = GameAssets.textures.uiAtlas.textures["fastOn.webp"];
        GlobalState.getInstance().updateState({ fastOn: true });
    }

    private _changeState(newState: FastButtonState) {
        if (this.currentState === newState) return; // No change if the same state

        // Enter logic for the new state
        this.currentState = newState;
        switch (this.currentState) {
            case FastButtonState.PASSIVE:
                this._onPassive();
                break;
            case FastButtonState.ACTIVE:
                this._onActive();
                break;
        }
    }
}
